import { render } from "./ModsArchiveComp.vue?vue&type=template&id=76c34d3b&scoped=true&ts=true"
import script from "./ModsArchiveComp.vue?vue&type=script&lang=ts"
export * from "./ModsArchiveComp.vue?vue&type=script&lang=ts"

import "./ModsArchiveComp.vue?vue&type=style&index=0&id=76c34d3b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c34d3b"]])

export default __exports__